module.exports = __webpack_public_path__ + "static/img/demoImage1.37b5dc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demoImage1.png
// module id = H3LM
// module chunks = 3